// Lightweight GA4 helper — no-ops when gtag is unavailable (blockers, SSR).
const safeGtag = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag(...args);
    }
  } catch (err) {
    // analytics must never break the app
    console.debug("analytics(gtag) call skipped:", err?.message);
  }
};

export const trackGaLead = (params = {}) =>
  safeGtag("event", "generate_lead", { currency: "CAD", ...params });

export default safeGtag;
